export default {
  tracksList: [],
  manageTrack: null
}
